// The deals endpoints' envelopes. Re-exported from '@/types/deal'.
import type { Deal } from './deal';

/**
 * Home-banner payload for an active referral payout boost. Top-level on the
 * deals index response (backend PR #149). null means NO banner — no boost,
 * kill switch thrown, or the bonus is conditioned/badge-only. Server-owned
 * so the banner disappears with no OTA when the window ends.
 */
export interface BonusPromo {
  deal_slug: string;
  brand_name: string;
  /** Offer name that tells sibling deals apart ("SoFi Invest"); brand_name is the company ("SoFi"). */
  display_name: string;
  /** Display string for the badge pill, e.g. "2x". */
  badge_label: string | null;
  /** Unboosted referrer cut — the "normally $20" half of the banner copy. */
  base_referrer_cut_cents: number;
  /** Boosted referrer cut the banner promises. */
  referrer_cut_cents: number;
  /** Bonus window end (ISO8601), or null for open-ended (omit the ends line). */
  ends_at: string | null;
  /**
   * Per-campaign banner copy authored in admin. The banner is opt-in: the
   * server only sends bonus_promo when a headline was authored, so it is
   * always present here. body null → app assembles the rate sentence.
   */
  headline: string;
  body: string | null;
}

/** Full GET /api/v1/deals envelope: the list plus the promo-banner payload. */
export interface DealsIndexResponse {
  deals: Deal[];
  bonus_promo: BonusPromo | null;
}

/**
 * The api client throws on non-2xx, so a successful click response is
 * always "ok". The shape we actually consume is `click_id` + `redirect_url`.
 */
export interface DealClickResponse {
  click_id: string;
  redirect_url: string;
}
